import {datadogRum} from '@datadog/browser-rum';
import {environment} from '../../environments/environment';
import {buildDatadogRumConfig} from './datadog-rum.config';

/**
 * Initializes client-side observability providers.
 * Angular route tracking is handled by the Datadog Angular router plugin.
 */
export function initializeObservability(): void {
  if (!environment.enableDatadogRum) return;

  datadogRum.init(buildDatadogRumConfig());
}
